<template>
  <section role="region" class="business-form-section" id="business-form">
    <div>
      <TheCard>
        <BusinessRdStationForm />
        <!-- <template #default>
          <TheSecondHead chipText="Vamos conversar?" titleText="Fale com o comercial"
            subtitleText="Para saber mais sobre nossos serviços e como eles podem transformar a maneira como você se comunica com seus clientes, preencha os campos abaixo:" />
          <TheForm :formFields="formFields" @input-change="handleChange" @handle-submit="handleSubmit" />
        </template> -->
      </TheCard>
    </div>
  </section>
</template>

<script setup lang="ts">

const formFields = ref<{ [key: string]: FormField }>({
  name: {
    name: "name",
    label: "Nome",
    type: "text",
    value: "",
    rules: [
      (value: string) => !!value || 'Campo obrigatório.',
      (value: string) => (value && value.length >= 4) || 'Mínimo 4 caracteres',
    ],
    appendInner: "mdi-account-outline",
  },
  company: {
    name: "company",
    label: "Empresa",
    type: "text",
    value: "",
    rules: [
      (value: string) => !!value || 'Campo obrigatório.',
      (value: string) => (value && value.length >= 3) || 'Mínimo 3 caracteres',
    ],
    appendInner: "mdi-briefcase-variant-outline",
  },
  phone: {
    name: "phone",
    label: "Telefone",
    type: "phone",
    value: "",
    rules: [
      (value: string) => !!value || 'Campo obrigatório.',
      (value: string) => (value && value.length >= 9) || 'Mínimo 9 caracteres',
    ],
    appendInner: "mdi-cellphone",
  },
  email: {
    name: "email",
    label: "E-mail",
    type: "email",
    value: "",
    rules: [
      (value: string) => !!value || 'Campo obrigatório.',
      (value: string) => {
        if (/.+@.+\..+/.test(value)) return true

        return 'E-mail must be valid.'
      },
    ],
    appendInner: "mdi-email-outline",
  },
  message: {
    name: "message",
    label: "Mensagem",
    type: "textarea",
    value: "",
    rules: [
      (value: string) => !!value || 'Campo obrigatório.',
      (value: string) => (value && value.length >= 3) || 'Mínimo 3 caracteres',
    ],
  },
});

const handleChange = (data: { name: string; value: string }) =>
  (formFields.value[data.name].value = data.value);

const handleSubmit = () => {
  console.log("form submitted", formFields.value);
};
</script>

<style lang="scss">
@use "@/styles/variables" as *;

.business-form-section {
  background-image: url(@/assets/images/contact/bg-mobile.webp);
  background-color: $purpleLight;
  background-repeat: no-repeat;
  background-position: center 100%;
  padding: 1px 20px;
  max-width: none;
  background-size: auto 1160px;

  .default-card {
    max-width: 470px;
    margin: 189px auto 283px;
    border-radius: 40px;
    justify-content: center;
    background-color: transparent;
    box-shadow: none;

    .title {
      margin: 16px auto;
    }

    .subtitle {
      margin-bottom: 44px;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-transition: background-color 9999s ease-in-out 0s;
      -moz-transition: background-color 9999s ease-in-out 0s;
      -o-transition: background-color 9999s ease-in-out 0s;
      transition: background-color 9999s ease-in-out 0s;
    }

    .v-field,
    .mdi {
      --v-medium-emphasis-opacity: 1 !important;
      color: $greyDark;
    }

    .form-field .v-text-field {
      width: 280px;
      margin: 0 auto;
    }

    .form-field .v-input__details {
      height: 24px;
    }

    .form-field:nth-child(4) .v-input__details {
      height: 16px;
    }

    .v-field__outline {
      --v-field-border-opacity: 1;
    }

    .default-button {
      margin-top: 12px;
    }
  }

  @media screen and (min-width: 834px) and (max-width: 1199px) {
    background-image: url(@/assets/images/contact/bg-tablet.webp);
    background-size: 802px 525px;

    .default-card {
      width: 470px;
      min-height: unset;
      text-align: center;

      .title {
        font-size: 40px;
      }

      .subtitle {
        margin: 0px 0px 44px;
      }

      .form-field .v-text-field,
      .file-select>.select-button {
        width: 370px;
      }
    }
  }

  @media screen and (min-width: 834px) {
    margin: 0px;

    .default-card {
      margin: 68px auto;

      .default-button {
        margin-top: 18px;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    background-image: url(@/assets/images/contact/bg-desk.webp);
    background-size: 1122.94px 733px;

    .default-card {

      .title {
        margin-bottom: 24px;
      }

      .subtitle {
        margin: 0px 0em 34px;
      }

      .form-field .v-text-field {
        width: 370px;
      }
    }
  }

}
</style>